<po-page-default
  p-title="Comparação de Arquivos"
  p-subtitle="Importe seus arquivos para comparação de dados."
  [p-breadcrumb]="breadcrumb"
>

  <!-- ════ FORMULÁRIO DE UPLOAD ════ -->
  <div [ngClass]="processamentoConcluido ? 'invisible' : ''">

    <div class="page-summary">
      <div class="page-summary-icon">
        <i class="an an-files"></i>
      </div>
      <div class="page-summary-text">
        <p class="po-font-subtitle">Ferramenta de comparação de arquivos TXT</p>
        <p class="page-summary-hint">Selecione dois arquivos e configure os parâmetros abaixo para iniciar a análise de divergências.</p>
      </div>
    </div>

    <po-divider></po-divider>

    <!-- Parâmetros -->
    <div class="comp-section po-mt-3">
      <div class="comp-section-header">
        <i class="an an-sliders-horizontal"></i>
        <span>Parâmetros</span>
      </div>
      <div class="comp-section-body">
        <div class="po-row">
          <po-input [(ngModel)]="grupos" name="grupos" class="po-md-6" p-label="Grupos" p-help="Informe os grupos separados por vírgula"></po-input>
          <po-number [(ngModel)]="tolerancia" name="tolerancia" class="po-md-6" p-label="Tolerância"></po-number>
        </div>
      </div>
    </div>

    <!-- Arquivos -->
    <div class="comp-section po-mt-3">
      <div class="comp-section-header">
        <i class="an an-upload-simple"></i>
        <span>Arquivos</span>
      </div>
      <div class="comp-section-body">
        <div class="comp-upload-grid">
          <div class="comp-upload-card">
            <div class="comp-upload-card-header">
              <i class="an an-file-text"></i>
              <div>
                <span class="comp-upload-card-title">Primeiro Arquivo</span>
                <span class="comp-upload-card-hint">Arquivo base para comparação</span>
              </div>
            </div>
            <po-upload
              #original
              [p-restrictions]="restrictions"
              [p-url]="urlPlaceholder"
              [p-hide-send-button]="true"
              (p-change)="verificarArquivosSelecionados()"
            ></po-upload>
          </div>

          <div class="comp-upload-versus">
            <i class="an an-arrows-left-right"></i>
          </div>

          <div class="comp-upload-card">
            <div class="comp-upload-card-header">
              <i class="an an-file-text"></i>
              <div>
                <span class="comp-upload-card-title">Segundo Arquivo</span>
                <span class="comp-upload-card-hint">Arquivo para confrontar</span>
              </div>
            </div>
            <po-upload
              #portal
              [p-restrictions]="restrictions"
              [p-url]="urlPlaceholder"
              [p-hide-send-button]="true"
              (p-change)="verificarArquivosSelecionados()"
            ></po-upload>
          </div>
        </div>
      </div>
    </div>

    <!-- Ação -->
    <div class="comp-action-bar po-mt-4 po-mb-4">
      <po-button
        (p-click)="processar()"
        p-label="Processar Comparação"
        p-icon="an an-play"
        p-kind="primary"
        [p-loading]="loading"
      ></po-button>
    </div>
  </div>

  <!-- ════ RESULTADO ════ -->
  <div [ngClass]="!processamentoConcluido ? 'invisible' : ''">

    <div class="comp-result-header po-mb-3">
      <div class="comp-result-header-info">
        <i class="an an-chart-bar"></i>
        <div>
          <span class="comp-result-title">Resultado da Comparação</span>
          <span class="comp-result-count">{{ itemsProcessados.length }} divergências encontradas</span>
        </div>
      </div>
      <po-button
        p-label="Nova Comparação"
        p-icon="an an-arrow-counter-clockwise"
        p-kind="secondary"
        (p-click)="reiniciarProcesso()"
      ></po-button>
    </div>

    <po-divider></po-divider>

    <div class="po-row po-mb-4 shadow">
      <po-table
        class="po-sm-12"
        [p-sort]="true"
        [p-columns]="columns"
        [p-hide-table-search]="false"
        [p-items]="itemsProcessados"
        [p-hide-columns-manager]="true"
        p-striped="true"
        p-container="border">
      </po-table>
    </div>
  </div>

</po-page-default>
